




























































































import { updateEnrollee, resendCompletionEmail } from '@adobe/edex/frontend/api/course';

export default {
  name: 'enrollee-actions',
  props: {
    enrollee: {
      default: () => {
        return {};
      },
      type: Object,
    },
    canRemove: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      show: false,
      action: '',
      comment: '',
      loading: false,
      error: false,
      resendLoading: false,
      resendError: false,
      resendSuccess: false,
      removeConfirmed: false,
    };
  },
  computed: {
    completed() {
      return this.enrollee.meta.passed;
    },
    completedDate() {
      return (
        this.enrollee.completedAt && this.lzDateFmt(this.enrollee.completedAt)
      );
    },
    lastReviewedDate() {
      return (
        this.enrollee.lastReviewedAt &&
        this.lzDateFmt(this.enrollee.lastReviewedAt)
      );
    },
    showComment() {
      return this.action === 'passed';
    },
  },
  methods: {
    async resendCompletionEmail() {
      const { courseID, memberID } = this.enrollee;
      this.resendLoading = true;

      try {
        const { status } = await resendCompletionEmail({ courseID, memberID });

        if (status === 200) {
          this.resendLoading = false;
          this.resendSuccess = true;
        } else {
          this.resendLoading = false;
          this.resendError = true;
        }
      } catch (error) {
        this.resendLoading = false;
        this.resendError = true;
      }
    },
    async submit() {
      if (this.action == 'removed' && !this.removeConfirmed) {
        return this.$modal.show('dialog', {
          title: `Remove ${this.enrollee.member.fullName}?`,
          text: '',
          buttons: [
            {
              title: 'Cancel',
              handler: () => {
                this.action = '';
                this.$modal.hide('dialog');
              },
            },
            {
              title: 'Confirm',
              default: true, // Will be triggered by default if 'Enter' pressed.
              handler: () => {
                this.removeConfirmed = true;
                this.submit();
                this.$modal.hide('dialog');
              },
            },
          ],
        });
      }

      const { courseID, memberID } = this.enrollee;
      this.loading = true;

      try {
        const payload = {
          memberID,
          status: this.action,
          reviewComment: this.comment,
        };

        const { data } = await updateEnrollee(courseID, payload);

        if (data) {
          this.$emit('onRowUpdated', data);
          this.action = '';
          this.comment = '';
          this.error = false;
          this.removeConfirmed = false;
          this.show = false;
        }
      } catch (error) {
        this.$emit('onRowUpdatedError');
        this.error = true;
        this.removeConfirmed = false;
      }

      this.loading = false;
    },
    handleClose() {
      this.show = !this.show;
      this.action = '';
      this.comment = '';
      this.loading = false;
      this.error = false;
      this.resendLoading = false;
      this.resendError = false;
      this.resendSuccess = false;
      this.removeConfirmed = false;
    },
  },
};
